export const getSelectDateWithCurrentTime = (selectDate) => {
  const currentDate = new Date();

  return selectDate.set({
    hours: currentDate.getHours(),
    minute: currentDate.getMinutes(),
    second: currentDate.getSeconds(),
  });
};

export const isFutureDate = (currentDate, nextDate) => nextDate.valueOf() > currentDate.valueOf();
